import React from 'react';
import { Grid } from '@mui/material';
import DetailsPanel from '../../../../../components/DetailsPanel';
import { ProductsTable } from '../../../Components/ProductsTable';
import EditInsurerOwnerFormModal from '../../../Forms/EditInsurerOwnerFormModal';
import { useInsurerInformationTab } from './useInsurerInformationTab';
import { InsurerDetails } from './InsurerDetails';
import { InsurerActions } from './InsurerActions';

export const InsurerInformationTab = () => {
  const {
    insurerId,
    insurer,
    insurerOwner,
    insurerContacts,
    isLoading,
    isLoadingInsurer,
    isOwner,
    canEdit,
    editModalOpen,
    handleOpenEditModal,
    handleCloseEditModal,
    handleEditInsurer,
  } = useInsurerInformationTab();

  const details = (
    <InsurerDetails
      insurer={insurer}
      insurerOwner={insurerOwner}
      insurerContacts={insurerContacts}
      isLoadingInsurer={isLoadingInsurer}
    />
  );

  const actions = isOwner ? (
    <InsurerActions disabled={isLoading || !insurer?.insurerId || !canEdit} onClick={handleOpenEditModal} />
  ) : null;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <DetailsPanel header={undefined} body={details} actions={actions} />
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <ProductsTable insurerId={insurerId || ''} products={insurer?.products || []} loading={isLoadingInsurer} />
        </Grid>
      </Grid>
      {editModalOpen && (
        <EditInsurerOwnerFormModal
          insurerOwner={insurerOwner}
          insurer={insurer}
          insurerContacts={insurerContacts}
          open={editModalOpen}
          onSubmit={handleEditInsurer}
          onHide={handleCloseEditModal}
        />
      )}
    </>
  );
};
